import "./scrollbarSlider.css";
import * as Yup from "yup";

import { Form, Formik } from "formik";
import { useContext, useRef, useState } from "react";
import useTheme from "../../../../../hooks/useTheme";
import { Box } from "@mui/system";
import RegistrationDetails from "./RegistrationDetails";
import { LoginTabContext } from "../../../../../contexts/LoginTabContext";
import PrimaryButton from "../../../../../components/custom/PrimaryButton";
import { Typography } from "@mui/material";
import { registerUser } from "../../../../../services/registerUserService";

import styled from "styled-components/macro";
import { useMutation } from "react-query";
import Dialog from "../../../../../components/custom/Dialog";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import { keySiteAtom } from "../../../../../atom/atoms";
import { useAtom } from "jotai";

// const ButtonBox = styled(Box)`
//   margin-top: 1rem;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
// `;

const AccountCreation = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40rem;
  flex-direction: column;
`;

const CreateAccount = () => {
  const { theme } = useTheme();
  const [captchaTheme] = useState(theme !== "DARK" ? "light" : "dark");
  const captchaRef = useRef(null);
  const AllMatches =
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
  const { t } = useTranslation();
  const [accountCreation, setAccountCreation] = useState(false);
  const { setValueTab } = useContext(LoginTabContext);
  const ref = useRef();
  const navigate = useNavigate();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [showOk, setShowOk] = useState(false);
  const [keySite] = useAtom(keySiteAtom);
  const { mutate } = useMutation(registerUser, {
    onSuccess: (data, variables, context) => {
      navigate("/auth/verify-registration");
    },
    onSettled: (data, error, variables, context) => {
      if (error) {
        setShowOk(true);
        setMessage(error.response.data);

        ref?.current?.setSubmitting(false);
      } else {
        setAccountCreation(true);
        setMessage("Account created");
        setIsDialogOpen(false);
      }
    },
  });

  const registerValidationSchema = Yup.object().shape({
    userFirstName: Yup.string().required("Please enter your first Name"),
    userLastName: Yup.string().required("Please enter your last Name"),
    userPassword: Yup.string()
      .required("Please enter your password")
      .matches(AllMatches, t("Please type password based on requirements")),
    userPassword2: Yup.string()
      .oneOf([Yup.ref("userPassword"), null], "Passwords must match")
      .required("Please retype your password"),
    userEmail: Yup.string()
      .email("Invalid Email")
      .required("Please enter your email"),
    userAddress: Yup.string().required("Please enter your address"),
    userCompanyName: Yup.string().required("Please enter your company name"),
  });

  const registerInitialValues = {
    userEmail: "",
    userPassword: "",
    userPassword2: "",
    userFirstName: "",
    userLastName: "",
    userAddress: "",
    userCompanyName: "",
    captcha: "",
  };

  const onSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    // setShowOk(false);
    setMessage("Creating account... please wait...");
    setIsDialogOpen(true);

    const valuesToSend = {
      email: values.userEmail,
      password: values.userPassword,
      firstName: values.userFirstName,
      lastName: values.userLastName,
      address: values.userAddress,
      companyName: values.userCompanyName,
      captcha: captchaRef.current.getValue(),
    };

    mutate(valuesToSend);

    captchaRef.current.reset();
    setTimeout(() => {
      setSubmitting(false);
    }, 1000);
  };

  return (
    <>
      {!accountCreation ? (
        <Formik
          innerRef={ref}
          initialValues={registerInitialValues}
          validationSchema={registerValidationSchema}
          onSubmit={onSubmit}
        >
          {({ submitForm, values, isSubmitting }) => (
            <Form>
              <RegistrationDetails values={values} />
              <ReCAPTCHA
                theme={captchaTheme}
                sitekey={keySite}
                ref={captchaRef}
              />
              <Box textAlign="right">
                <PrimaryButton disabled={isSubmitting} onClick={submitForm}>
                  {}Submit
                </PrimaryButton>
              </Box>
            </Form>
          )}
        </Formik>
      ) : (
        <AccountCreation>
          <Typography variant="h5" sx={{ textAlign: "center" }}>
            Activation link has been sent to your email
          </Typography>
          <PrimaryButton sx={{ mt: 4 }} onClick={() => setValueTab("1")}>
            Back to Login Page
          </PrimaryButton>
        </AccountCreation>
      )}
      <Dialog
        showOk={showOk}
        showCancel={false}
        showButton={false}
        action={() => {
          setShowOk(false);
          setIsDialogOpen(false);
        }}
        onClose={() => {
          setShowOk(false);
          setIsDialogOpen(false);
        }}
        open={isDialogOpen}
      >
        {message}
      </Dialog>
    </>
  );
};

export default CreateAccount;
